import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../../services';
import { Subject } from 'rxjs';
import { ManageService } from '../../../services/manage.service';
import { BulkOrderValidationResult} from '../../../models/csp.model';
import { FileService } from '../../../services/file.service';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ApiResponse } from '../../../models/api-response.model';
import { NgProgressService } from "../../../services/ngProgress.service";
import { CurrentUserModel } from "../../../models/account-ledger.model";
import { AuthService } from '../../../services/auth.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-bulk-order',
  templateUrl: './bulk-order.component.html',
  styleUrls: ['./bulk-order.component.css']
})
export class BulkOrderComponent implements OnInit, OnDestroy {

  setFullWindow = false;
  title = 'Bulk Order Creation';
  comparedValue = 'text';
  file: any;
  loadContent = true;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  public fileName: string;
  finishLoading = true;
  currentUserModel: CurrentUserModel;
  tabIndex: string;
  dataIndex: number; 
  dataList: Array<number> = [];  
  public displayedColumns: string[] = [
    'tenantDescription',
    'stockCode',
    'offerDescription',
    'quantity',
    'coterm',
    'status',
    'action'
  ];
  public inProgressColumns: string[] = [
    'tenantDescription',
    'stockCode',
    'offerDescription',
    'quantity',
    'coterm',
    'status'
  ];
  public archiveColumns: string[] = [
    'tenantDescription',
    'stockCode',
    'offerDescription',
    'quantity',
    'coterm',
    'status',
    'manage'
  ];
  
  public resultTableDataSrc: BulkOrderValidationResult[] = [];
  disableUpload: boolean;
  tooltipUpload: string;

  constructor(
    private router: Router,
    private manageService: ManageService,
    private commonService: CommonService,
    private fileService: FileService,
    private ngProgress: NgProgressService,
    private authService: AuthService
  ) {
  }
  ngOnInit() {
    
    this.authService.getLoginInfo()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: CurrentUserModel) => {
          this.currentUserModel = res;
          
          if(!res.hasPurchaseAccess && res.hasAdminAccess) {
            this.disableUpload = true;
            this.tooltipUpload = 'Requires Purchasing Permissions'
          }
          else if(res.hasPurchaseAccess && !res.hasAdminAccess) {
            this.disableUpload = true;
            this.tooltipUpload = 'Requires Admin Permissions'
          } else if(!res.hasPurchaseAccess && !res.hasAdminAccess){
            this.disableUpload = true;
            this.tooltipUpload = 'Requires Admin and Purchasing Permissions'
          }
        },
        (error: any) => {
          console.info(error);
        }
      );
    $('#levelOne').animate({ scrollLeft: 250 }, 400);
    this.manageService.GetBulkOrderData("Import Bulk Orders").subscribe((res:any)=> {
      this.loadContent = true;
      this.resultTableDataSrc = res;
    }, (error: any) => {
      this.commonService.implementToast(error?.responseMessage, 'Error');
    });
  }

  onSelectFile(event): void {
    this.loadContent = false;
    this.file = event.target.files[0];
    this.fileName = this.file?.name;
    //this.resultTableDataSrc = [];
    this.loadContent = true;
  }

  onImportBulkOrders(): void {
    this.loadContent = false;
    const formData = new FormData();
    formData.append(this.file.name, this.file);
    this.manageService
      .importBulkOrder(formData)
      .subscribe((res: BulkOrderValidationResult[]) => {
        this.loadContent = true;
        this.resultTableDataSrc = res;
      }, (error: any) => {
        this.commonService.implementToast(error?.responseMessage, 'Error');
      });
  }

  checkStatusLink() {
    window.open("https://admin.microsoft.com/Adminportal/Home?invType=ResellerRelationship&partnerId=87dd1e14-7503-4c96-b552-2b4adc3f3bcc&msppId=0#/partners/invitation", "_blank");
  }

  drop(ev) {
    this.loadContent = false;

    // Prevent default behavior (Prevent file from being opened)
    ev.preventDefault();

    if (ev.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      [...ev.dataTransfer.items].forEach((item, i) => {
        // If dropped items aren't files, reject them
        if (item.kind === "file") {
          const file = item.getAsFile();
          this.file = file
          this.fileName = this.file.name;
          this.resultTableDataSrc = [];
        }
      });
    }
    this.loadContent = true;
  }


  allowDrop(ev) {
    ev.preventDefault();
  }

  downloadSampleFile(): void {
    this.loadContent = false;
    this.fileService.saveFile('CSP_Bulk_Order_Creation_Template.xlsx').subscribe(res => {
      this.fileService.saveAsExcelFile(res, 'CSP_Bulk_Order_Creation_Template.xlsx');
      this.loadContent = true;
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });

  }
  downloadInstructionFile():void{
    this.loadContent = false;
    this.fileService.saveFile('New Bulk Order Creation Feature.pdf').subscribe(res => {
      this.fileService.saveAsExcelFile(res, 'New Bulk Order Creation Feature.pdf');
      this.loadContent = true;
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  close() {
    this.router.navigateByUrl('/manageSubscriptions/manageAnnuities/CSP');
    $('#levelOne').animate({ scrollLeft: 0 }, 400);
  }

  myTabSelectedTabChange(event: MatTabChangeEvent) {
    const tabName = event.tab.textLabel;
    this.manageService.GetBulkOrderData(tabName).subscribe((res:any)=> {
      this.loadContent = true;
      this.resultTableDataSrc = res;
    }, (error: any) => {
      this.commonService.implementToast(error?.responseMessage, 'Error');
    });
    
  }
 
  actionCreateRemoveRetry(rowId: number, action: string) {
    this.dataList = [];
    this.loadContent = false;  
    this.dataList.push(rowId);   
    this.manageService
      .actionCreateRemoveRetry(this.dataList, action)
      .subscribe((res: ApiResponse) => {    
        if (res.status === true) {
          this.manageService.GetBulkOrderData("Import Bulk Orders").subscribe((res:any)=> {
            this.loadContent = true;
            this.resultTableDataSrc = res;
          });        
         
      } else {
          this.commonService.implementToast(res.responseMessage, "Error");
      }    
        
      }, (error: any) => {
        this.commonService.implementToast(error?.responseMessage, 'Error');
      });

  }

  actionCreateRemoveAll(action) {  
    this.dataList = [];
    this.loadContent = false;
    this.resultTableDataSrc.forEach(r => {     
      this.dataList.push(r.rowId);
    })
    
    this.manageService
    .actionCreateRemoveRetry(this.dataList, action)
    .subscribe((res: ApiResponse) => {    
      if (res.status === true) {
        this.manageService.GetBulkOrderData("Import Bulk Orders").subscribe((res:any)=> {
          this.loadContent = true;
          this.resultTableDataSrc = res;
        });        
       
    } else {
        this.commonService.implementToast(res.responseMessage, "Error");
    }    
      
    }, (error: any) => {
      this.commonService.implementToast(error?.responseMessage, 'Error');
    });

}
public navToTenantDetailPage(tenantId: string): void {
  this.router.navigateByUrl(
    this.router.createUrlTree(
      [`/manageSubscriptions/manageAnnuities/CSP/CSPDetailsNew/${tenantId}`], { queryParamsHandling: 'preserve' }
    )
  );
}
public navtoToManageSubscription(tenantId: string,subscriptionId: string): void {  
  this.router.navigateByUrl(
  this.router.createUrlTree(
    [`/manageSubscriptions/manageAnnuities/CSP/CSPDetailsNew/${tenantId}/ManageLicenseSubscriotion/SubscriptionDetails;sub=${subscriptionId}`], { queryParamsHandling: 'preserve' }
    
  )
  );
}
exportBulkOrderReport():void{
  this.finishLoading = false;
  this.ngProgress.start();

  /* this.manageService
    .ExportBulkOrderReport()
    .subscribe(
      (data: any) => {
        const fileName = `Bulk Order report ${this.currentUserModel.accountId}.xlsx`;
        this.fileService.saveAsExcelFile(data, fileName);
        this.finishLoading = true;
        this.ngProgress.done();
      },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      }
    ); */
}
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
